import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import PinInput from 'react-pin-input';
import { PulseLoader } from 'halogenium';
import AppData from '../../Model/AppData'
import { FaCheckCircle } from "react-icons/fa";

class PromptPinModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#pin-modal').length == 0) {
            $('body').prepend('<div id="pin-modal"></div>')
        }
        this.portalRoot = document.getElementById("pin-modal");
        this.el = document.createElement("div");
        this.pinRef = React.createRef();
    }
    componentDidMount = () => {
        this.portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        this.portalRoot.removeChild(this.el);
    };
    onClose = () => { }
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}

class PromptPinModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isInvalid: false,
            errorMessage: null,
            isSuccess: false
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup', this.escListener)
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                this.props.onClose && this.props.onClose()
            }
        }
        this.escListener = (event) => {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '27') {
                this.props.onClose && this.props.onClose()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener)
        $(document).keyup(this.escListener)
        setTimeout(() => {
            this.pinRef.focus()
        }, 500)
    }
    onClose = () => { }
    render() {
        return (
            <PromptPinModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="bounceInDown">
                    {this.renderBody()}
                </Modal>
            </PromptPinModalPortal>
        )
    }
    onVerifyPin = (pin) => {
        this.setState({
            isLoading: true
        })
        let newState = {};
        if (pin == null || pin == undefined) {
            this.setState({
                isInvalid: true,
                isLoading: false,
                errorMessage: null
            })
        } else { //PIN correct
            AppData.createTableSession(pin).then(() => {
                this.setState({
                    isSuccess: true,
                    isInvalid: false,
                    isLoading: false,
                    errorMessage: null
                })
                setTimeout(() => {
                    this.props.onClose()
                }, 1000);
            }).catch((error) => {
                console.log(error);
                this.setState({
                    isInvalid: true,
                    isLoading: false,
                    errorMessage: error
                })
            })
        }
    }
    renderBody = () => {
        if (this.state.isLoading) {
            return (<div className="text-center">
                <h3>Joining Table</h3>
                <PulseLoader color="#ffa733" size="8px" style={{ textAlign: "center", paddingTop: '6px', height: "38px" }} />
            </div>)
        } else if (this.state.isSuccess) {
            return (<div className="text-center">
                <h3><FaCheckCircle style={{ color: 'green' }} size='30px' /><div>Success</div></h3>
            </div>)
        }
        return (<div className="menu-modal" style={{ padding: "20px" }}>
            <div id="pin-value" className="text-center">
                <span>{this.props.message}</span>
                <PinInput
                    length={4}
                    type="numeric"
                    focus={true}
                    style={{ padding: '10px' }}
                    inputFocusStyle={{ borderColor: 'blue' }}
                    ref={(n) => this.pinRef = n}
                    onComplete={(value, index) => {
                        this.onVerifyPin(value)
                    }}
                />
                {this.state.isInvalid && <span style={{ color: "red", fontSize: 'smallest' }}>{this.state.errorMessage || "Invalid PIN, please try again"}</span>}
            </div>
            <div style={{ textAlign: "center", marginTop: "8px" }}>
                <button onClick={this.props.onClose} className="btn btn-link btn-light">Later</button>
            </div>
        </div>)
    }
}
PromptPinModal.defaultProps = {
    message: ""
}
export default PromptPinModal;